import { recipe } from "@vanilla-extract/recipes";
import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    wordBreak: "break-word",
  },
  variants: {
    variant: {
      hub: {},
      history: {
        vars: {
          "--node-margin": theme.spacings.s,
        },
      },
      sideContent: {
        vars: {
          "--node-margin": theme.spacings.s,
        },
      },
    },
  },
});
